

import { UploadFile } from 'antd';
import { RcFile } from 'antd/lib/upload';
import { UploadFileStatus } from 'antd/lib/upload/interface';

export class UploadFileClass implements UploadFile {
    uid!: string;
    size?: number | undefined;
    name!: string;
    fileName?: string | undefined;
    lastModified?: number | undefined;
    lastModifiedDate?: Date | undefined;
    url?: string | undefined;
    status?: UploadFileStatus | undefined;
    percent?: number | undefined;
    thumbUrl?: string | undefined;
    crossOrigin?: '' | 'anonymous' | 'use-credentials' | undefined;
    originFileObj?: RcFile | undefined;
    response?: any;
    error?: any;
    linkProps?: any;
    type?: string | undefined;
    xhr?: any;
    preview?: string | undefined;

    constructor(file: File, filename: string, percent: number = 0, fileurl?: string) {
        this.uid = `${filename}-${new Date().valueOf()}`
        this.lastModified = file.lastModified
        this.lastModifiedDate = new Date(file.lastModified)
        this.name = file.name
        this.size = file.size
        this.type = file.type
        this.status = 'done'
        this.percent = percent // set the percentage to 100 to know if the file has already been uploaded to the storage
        this.url = fileurl
        this.originFileObj = file as RcFile
    }
}